export default "__VITE_ASSET__DviYHCDS__"